import { getEnv, VUE_APP_LANDING_PAGE, VUE_IS_TEST } from '#/utils/env';
import store from '#/store';

export default function addAllowedToTestRuleToRouter(router) {
  // checks if the may_test or may_beta flags are required / present.
  router.beforeEach((to, from, next) => {
    // check against string 'true' because bools aren't allowed as envs in our k8s charts
    const isTest = getEnv(VUE_IS_TEST) === 'true';
    if (isTest) {
      // allow pass through if explicitly granted from tokens, else redirect
      if (store.getters['user/mayTest']) {
        next();
        return;
      }
      console.error('router - testing not allowed');
      window.location.replace(getEnv(VUE_APP_LANDING_PAGE));
    }
    next();
  });
}
